<template>
  <g>
    <path
      fill="none"
      d="M0 0h24v24H0z"
    /><g fill="current">
      <path
        data-name="Pfad 1270"
        d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm0 18.182A8.182 8.182 0 1 1 20.182 12 8.182 8.182 0 0 1 12 20.182Z"
      /><path
        data-name="Pfad 1271"
        d="M12.907 11.626V6.538a.912.912 0 1 0-1.823 0v5.476a.892.892 0 0 0 .017.172c.005.028.016.053.024.081a.912.912 0 0 0 .028.09.937.937 0 0 0 .047.09c.012.023.022.046.036.067a.888.888 0 0 0 .114.14l2.578 2.578a.912.912 0 0 0 1.29-1.289Z"
      />
    </g>
  </g>
</template>
